import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { groupRoleByUserId } from 'helpers/groupRoleByUserId'
import { useProjectUserStatus } from 'hooks/useProjectUserStatus'
import { openUserRoleModalAction } from 'store/modals'
import Scrollbar from 'ui/components/Scrollbar'
import { getProjectUsersByStatus } from 'ui/components/UserStatusControl/helpers'
import UserList from './components/UserList'
import {
  Wrapper,
  Heading,
  UserRoleLabel,
  UserRoleButton,
  UserListWrap,
} from './styled'

const UserRoleWidget = ({
  onCloseHandler,
  users,
  projectSlug,
  canEditProjectSettings,
}) => {
  const [hasVerticalScroll, setHasVerticalScroll] = useState(false)

  const dispatch = useDispatch()

  const openUserRoleModal = (projectSlug) => {
    dispatch(openUserRoleModalAction({ projectSlug }))
  }

  const {
    changingUserId,
    handleDeactivateProjectUser,
    handleActivateProjectUser,
  } = useProjectUserStatus({ slug: projectSlug })

  const { activeUsers, inactiveUsers, activeManagersCount } =
    getProjectUsersByStatus(groupRoleByUserId(users) || [])

  if (!users) {
    return null
  }

  return (
    <>
      <Wrapper>
        <Heading>
          <UserRoleLabel>Участники проекта</UserRoleLabel>

          {canEditProjectSettings && (
            <UserRoleButton
              theme="borderBlue"
              size="medium"
              title="Редактировать участников"
              onClick={(event) => {
                event.preventDefault()
                openUserRoleModal(projectSlug)
              }}
            />
          )}
        </Heading>

        <Scrollbar
          maxHeight={280}
          onVerticalScrollChange={setHasVerticalScroll}
        >
          <UserListWrap $hasVerticalScroll={hasVerticalScroll}>
            {activeUsers.length > 0 && (
              <UserList
                users={activeUsers}
                title="Активные"
                onCloseHandler={onCloseHandler}
                activeManagersCount={activeManagersCount}
                changingUserId={changingUserId}
                onStatusChange={handleDeactivateProjectUser}
                canEditProjectSettings={canEditProjectSettings}
              />
            )}

            {inactiveUsers.length > 0 && (
              <UserList
                users={inactiveUsers}
                title="Неактивные"
                onCloseHandler={onCloseHandler}
                activeManagersCount={activeManagersCount}
                changingUserId={changingUserId}
                onStatusChange={handleActivateProjectUser}
                canEditProjectSettings={canEditProjectSettings}
              />
            )}
          </UserListWrap>
        </Scrollbar>
      </Wrapper>
    </>
  )
}

export default UserRoleWidget
